import React from 'react'
import { Icon } from 'antd'
import '../../../styles/work_stage.css'


export default {
	"fields": [
		[
			{
				"title": "Nome",
				"key": "name",
				"type": "text",
				"element-attr": {
					required: true,
					prefix: <Icon type="tags" />
				}
			},
		]
	],
	submit: {
		collection: "WorkStage"
	},
	className: "config-component",
	schema: [
		{
			title: "Nome",
			key: "name",
			dataIndex: "name",
			type: "text",
			className: "name"
		}
	],
	"title-navigation": <div><Icon type="home" /> Estágio da Obra</div>,
	"title-module": "Estágio da Obra",
	"module": "TypeWork",
	"router-base": "/panel/estagio-obra"
}